import React from 'react';
import { ComplianceReview } from './components/ComplianceReview';
export function App() {
  return <ComplianceReview data-id="element-0" />;
}